import { useSelector } from "react-redux";
import { Link } from "react-router";

import { authSelector } from "../reducers";
import { logoUrl } from "../common/utils.jsx";
import styled from "styled-components";
import { IconPinLocked, IconPinUnlocked } from "./icons.jsx";

const LogoBoxStyled = styled.div`
  position: relative;
  height: 3.75rem;
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.1);

  .logo {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }
`;

const LockingButton = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0.9rem;
  right: 0.5rem;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
`;

export default function LogoBox({ isLocked, toggleLocked, expanded }) {
  const { companyLogoUrl, companyName, company, personalProfile } = useSelector(authSelector);
  const organizationLogoUrl = company?.logoUrl;
  const logo = logoUrl(companyLogoUrl, organizationLogoUrl);

  return (
    <LogoBoxStyled>
      <Link to={personalProfile ? "/personal/dashboard" : "/"}>
        {logo ? (
          <figure className="logo" style={{ background: `url("${logo}") center/contain no-repeat` }} />
        ) : (
          <span>{companyName}</span>
        )}
      </Link>
      {expanded && (
        <LockingButton onClick={toggleLocked}>{isLocked ? <IconPinLocked /> : <IconPinUnlocked />}</LockingButton>
      )}
    </LogoBoxStyled>
  );
}
